import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { EditorPlugin } from './../../ricos-types';

import { listItem } from './extension';
import { listItemConverter } from './list-converters';

export const pluginListItem: EditorPlugin = {
  type: Node_Type.LIST_ITEM,
  config: {},
  pmMarkConverters: [],
  pmNodeConverters: [listItemConverter],
  tiptapExtensions: [listItem],
};
